module.exports = __webpack_public_path__ + "img/Circulo-Logo-TesteoMaterial.96798829.png";